<template>
  <div class="nav-header">
    <div class="container">
      <!-- logo -->
      <div class="n-logo"> 点思传媒</div>
      <!-- 导航 -->
      <div class="n-list">
        <!-- <a href="/" class="active">首页</a> -->
        <a href="/" class="active">行业资讯</a>
        <!-- <a href="/#/ac1">最新热门</a> -->
        <!-- <a href="/#/ac2">行业资讯</a> -->

        <a href="/#/info">关于我们</a>
      </div>
      <!-- 登录注册 -->
      <div class="n-login">
        <span class="n-login" @click="goLogin()" v-show="this.LoggedShow">
          <i class="iconfont icon-denglu"></i>
          登录
        </span>
        <span class="n-login" @click="goRegister()" v-show="this.LoggedShow">
          <i class="iconfont icon-zhuce"></i>
          注册
        </span>
        <!-- 用户名 -->
        <span
          class="n-info"
          v-show="!this.LoggedShow"
          v-text="this.nv_user.Username"
          ><i class="iconfont icon-denglu"></i
        ></span>

        <!-- 退出登录 -->
        <span class="n-info" @click="tolg()" v-show="!this.LoggedShow">
          <i class="iconfont icon-tuichudenglu"></i>
          退出登录
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "nav-header",
  data() {
    return {
      // 按钮显示/隐藏
      LoggedShow: true,
      // 获取到 user 用户信息
      nv_user: JSON.parse(window.localStorage.getItem("user")),
      // 存储状态
      state: JSON.parse(window.localStorage.getItem("state")),
    };
  },
  mounted() {
    this.logged();
  },
  methods: {
    // 登录时隐藏逻辑
    logged() {
      if (this.state == "0") {
        this.LoggedShow = false;
      }
    },
    // 登录跳转
    goLogin() {
      this.$router.push("/login");
    },
    // 注册跳转
    goRegister() {
      this.$router.push("/register");
    },
    // 退出登录
    tolg() {
      window.localStorage.setItem("state", "10");
      this.LoggedShow = true;
      location.reload();
      // this.$forceUpdate()
    },
    // 跳转最新文章
    goAc1() {
      this.$router.push("/ac1");
    },
    // 跳转行业资讯
    goAc2() {
      this.$router.push("/ac2");
    },
    // 跳转独加新闻
    goAc3() {
      this.$router.push("/ac3");
    },
    // 跳转关于我们
    goInfo() {
      this.$router.push("/info");
    },
    // 跳转注册协议
    goXy() {
      this.$router.push("/xy");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.nav-header {
  width: 100%;
  height: 80px;
  position: fixed;
  top: 0;
  left: 0;
  background: #fff;
  z-index: 10;
  box-shadow: 0px 15px 10px -15px #000;
  .container {
    height: 100%;
    // background-color: pink;
    @include flex();
    // logo
    .n-logo {
      width: 300px;
      height: 80px;
      // img {
      //   width: 100%;
      //   height: 100%;
      // }
      font-size: 21px;
      font-weight: bold;
      color: $colorZ;
      line-height: 80px;
    }
    // 导航
    .n-list {
      width: 500px;
      height: 100%;
      // background-color: #c60023;
      display: flex;
      justify-content: center;
      align-content: center;
      a {
        flex: 1;
        text-align: center;
        font-size: 16px;
        color: #121212;
        margin: 0 15px;
        display: inline-block;
        height: 80px;
        line-height: 80px;
        // background-color: #fff;
        transition: all 0.2s;
        &.active {
          font-weight: bold;
          font-size: 18px;
        }
        &:hover {
          color: #4889db;
        }
      }
    }
    // 登录注册
    .n-login {
      span {
        font-size: 16px;
        margin: 0 15px;
        cursor: pointer;
      }
    }
  }
}
</style>